module.exports = __webpack_public_path__ + "img/4.49b80c52.jpg";